import { render, staticRenderFns } from "./CrmIcon.vue?vue&type=template&id=c58f0f96&scoped=true"
import script from "./CrmIcon.vue?vue&type=script&lang=js"
export * from "./CrmIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58f0f96",
  null
  
)

export default component.exports